import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useProjectOverview from "./useProjectOverview";

// In projectOverview(including AddEdit's folder and subfolder), the id represents the projectId, and action represents the project action (Add, View, or Edit).

const ProjectOverview = () => {
  const {
    projectList,
    isProjectListLoading,
    onAdd,
    globalFilter,
    setGlobalFilter,
    columns,
    isMobile,
    showInActiveConfirmation,
    setShowInActiveConfirmation,
  } = useProjectOverview();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Project Overview" />
          {isMobile && (
            <Button onClick={onAdd} className="px-2">
              + Add
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAdd}>+ Add</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isProjectListLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(projectList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
        </>
      )}

      {showInActiveConfirmation && (
        <Dialog
          open={showInActiveConfirmation}
          setOpen={setShowInActiveConfirmation}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
            </div>
          }
          hideFooter
        >
          <div>
            ❗ Critical Workflow Alert: Impacted Project Assignments
            Deactivating [User Name] will remove their assigned responsibilities
            from the following active projects: Project Name User's
            Role/Assignment [Project A Name] PM [Project B Name] PM [Project C
            Name] PM Action Required: You must ensure these assignments are
            handled by an active user. Do you wish to proceed with deactivation,
            acknowledging that you will immediately manage the reassignment of
            [User Name]'s project duties?
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default ProjectOverview;
